import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store =  new Vuex.Store({
    state: {
        // 创建了一个公共的变量
        tel:"",
        fkform: {
            fkname: "",
            fkid: "",
            fkdw: "",
            fkphone: "",
            fkcph: "",
            sfks: ""
        }
    },
    mutations: {
        changTel(state,tel){
            state.tel = tel;
        },
        changFkform(state,fkform){
            state.fkform = fkform
        }
    },
    actions: {
    },
    getters: {
    },
    modules: {
    }    
})

export default store
